import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetLookUpDropdownListQuery } from '../../../../../api/endpoints/lookup';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const CountryCodeDropdown = ({ value, onChange, className, placeholder = 'Select a country', disabled = false }) => {
    const { getCurrentLanguageId } = useLanguage();
    const lang = Number(getCurrentLanguageId?.());
    const { data: raw = [], isLoading } = useGetLookUpDropdownListQuery({
        GroupCode: 'COUNTRIES',
        LanguageId: lang === 1 || lang === 2 ? lang : 1
    });

    const items = useMemo(() => {
        if (Array.isArray(raw)) return raw;
        if (raw && Array.isArray(raw.data)) return raw.data;
        return [];
    }, [raw]);

    return (
        <Dropdown
            value={value || null}
            onChange={(e) => onChange && onChange(e.value)}
            options={items}
            optionLabel="translatedText"
            optionValue="code"
            dataKey="code"
            className={className}
            placeholder={placeholder}
            disabled={disabled || isLoading}
            loading={isLoading}
            filter
            filterBy="translatedText,code"
            showClear
            emptyMessage="No countries found"
            emptyFilterMessage="No countries found"
            appendTo="self"
        />
    );
};

export default CountryCodeDropdown;
